<template>
  <v-card class="mb-4 hvh-card--rounded hvh-analysis-segments" hide-details>
    <CardTitle :title="title" :class="{ 'pb-0': !isCollapsed }" v-model="isCollapsed" :help="help" />
    <div class="hvh-categories" v-show="!isCollapsed">
      <v-card-text class="pt-0">
        <v-radio-group hide-details>
          <InputRadio color="primary" :class="{ disabled: item.disabled }" :label="item.label || item.join(' / ')" :value="(item.value || item) === value" @input="$emit('input', item)" hide-details v-for="item in items" :key="item.value" />
        </v-radio-group>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import CardTitle from '../common/cardTitle/HvhCardTitle.vue';
import InputRadio from '../common/form/inputRadio/HvhInputRadio';

export default {
  components: {
    CardTitle,
    InputRadio,
  },
  props: ['title', 'items', 'value', 'help'],
  data() {
    return {
      isCollapsed: false,
    };
  },
};

</script>

<style lang="scss" scoped>
.hvh-categories {
  overflow-x: hidden;
  overflow-y: auto;
}

.hvh-analysis-segments {
  .v-input {
    display: block;
  }

  .v-label {
    color: $color-text-default;
    font-size: rem(14px);
  }
}

.hvh-analysis-segments__checkbox--lvl2 {
  padding-left: rem(12px);
}

.v-input--selection-controls {
  margin-top: 4px;
}
</style>
